import Projects from "../components/Projects";
import Footer from "../components/Footer";
import Header from "../components/Header";

function ProjectsPage () {
  return (
		<>
      	  <Header />
		  <Projects />
		  <Footer />
		</>
	)
}

export default ProjectsPage;
